(function () {
  'use strict';

  if (!document.body.classList.contains('template-index')) return;

  /* ---- Sticky header (solid bar) ---- */
  const header = document.querySelector('#header-component');
  if (header) {
    header.classList.add('luxury-header--solid');
  }

  /* ---- Inject wishlist icon in header ---- */
  const headerActions = document.querySelector('header-actions');
  if (headerActions && !headerActions.querySelector('.luxury-wishlist-btn')) {
    const wishlistBtn = document.createElement('button');
    wishlistBtn.className = 'luxury-wishlist-btn header-actions__action';
    wishlistBtn.setAttribute('aria-label', 'Wishlist');
    wishlistBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/></svg>';
    const accountBtn = headerActions.querySelector('.account-button, shopify-account');
    if (accountBtn) {
      headerActions.insertBefore(wishlistBtn, accountBtn);
    } else {
      headerActions.prepend(wishlistBtn);
    }
  }

  /* ---- Intersection Observer fade-up animations ---- */
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReduced) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.luxury-animate').forEach((el) => observer.observe(el));
  } else {
    document.querySelectorAll('.luxury-animate').forEach((el) => el.classList.add('is-visible'));
  }

  /* ---- Hero parallax ---- */
  const heroMedia = document.querySelector('.luxury-hero__media img');
  if (heroMedia && !prefersReduced) {
    window.addEventListener(
      'scroll',
      () => {
        const hero = document.querySelector('.luxury-hero');
        if (!hero) return;
        const rect = hero.getBoundingClientRect();
        if (rect.bottom > 0) {
          const offset = window.scrollY * 0.25;
          heroMedia.style.transform = `scale(1.05) translateY(${offset}px)`;
        }
      },
      { passive: true }
    );
  }

  /* ---- Product wishlist toggle ---- */
  document.querySelectorAll('.luxury-product-card__wishlist').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-active');
      const svg = btn.querySelector('svg');
      if (btn.classList.contains('is-active')) {
        svg.setAttribute('fill', 'currentColor');
      } else {
        svg.setAttribute('fill', 'none');
      }
    });
  });
})();
